import React from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { SFPalette } from '@/lib/color';
import Stack, { StackProps } from '@mui/material/Stack';
import { fontWeight, inter } from '@/theme';
import List, { ListProps } from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { ChevronRight } from '@mui/icons-material';

function Menu({
  children,
  ...props
}: {
  children: React.ReactNode;
} & ListProps) {
  return <List {...props}>{children}</List>;
}

function BetweenItem({
  onClick,
  leftContent,
  rightContent,
  stackProps,
}: {
  onClick?: () => void;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  stackProps?: StackProps;
}) {
  const Content = () => {
    return (
      <Stack direction="row" justifyContent="space-between" width="100%" {...stackProps}>
        {leftContent}
        {rightContent}
      </Stack>
    );
  };
  if (onClick) {
    return (
      <ListItemButton
        onClick={onClick}
        sx={{
          px: 0,
          width: '100%',
        }}
      >
        <Content />
      </ListItemButton>
    );
  }

  return (
    <ListItem
      sx={{
        width: '100%',
        px: 0,
      }}
    >
      <Content />
    </ListItem>
  );
}

function ArrowButtonGroupItem({
  title,
  items,
}: {
  title: string;
  items: {
    href: string;
    name: string;
    onClick?: () => void;
  }[];
}) {
  const navigate = useNavigate();
  return (
    <Stack>
      <Typography variant="subtitle2" py={1} color={SFPalette.grey2} fontWeight={fontWeight.Medium}>
        {title}
      </Typography>
      {items.map((item, index) => (
        <ListItemButton
          key={item.name + '-' + index}
          sx={{
            justifyContent: 'space-between',
            px: 0,
          }}
          onClick={() => {
            item.onClick && item.onClick();
            if (!item.href) return;
            navigate(item.href);
            // router.push(item.href);
          }}
        >
          <Typography variant="h6" fontWeight={fontWeight.Medium}>
            {item.name}
          </Typography>
          <ChevronRight
            sx={{
              color: SFPalette.lightGrey2,
            }}
          />
        </ListItemButton>
      ))}
    </Stack>
  );
}

function ArrowRightItem({ onClick, text }: { onClick?: () => void; text: string }) {
  return (
    <ListItemButton
      sx={{
        justifyContent: 'space-between',
        px: 0,
      }}
      onClick={onClick}
    >
      <Typography variant="h6" fontWeight={fontWeight.Medium}>
        {text}
      </Typography>
      <ChevronRight
        sx={{
          color: SFPalette.lightGrey2,
        }}
      />
    </ListItemButton>
  );
}

const SFMenu = {
  Menu,
  BetweenItem,
  ArrowButtonGroupItem,
  ArrowRightItem,
};

export default SFMenu;
